/* ==========================================================================
   Hout gemak — native winkelwagen-drawer logica (AJAX cart)
   ========================================================================== */
(function () {
  'use strict';
  var CFG = window.HGCartConfig || {};
  var MONEY = CFG.moneyFormat || '&euro;{{amount_with_comma_separator}}';
  var THRESHOLD = CFG.freeShipThreshold || 0;
  var S = CFG.strings || {};

  /* ---------- geld formatteren (Shopify-standaard) ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, d) { return (isNaN(n) || n == null) ? d : n; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = MONEY.match(placeholderRegex);
    var fmt = match ? match[1] : 'amount';
    switch (fmt) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    // Verwijder eventuele HTML-wrappers uit het geldformaat (bv. <span class=dualPrice>)
    return MONEY.replace(placeholderRegex, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- helpers ---------- */
  function el(id) { return document.getElementById(id); }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(src, w) { if (!src) return ''; return src.indexOf('?') > -1 ? src + '&width=' + w : src + '?width=' + w; }

  var drawer, overlay, body, foot, countEls, loading = false, notesOpen = false;

  function setLoading(on) { loading = on; if (drawer) drawer.classList.toggle('is-loading', on); }

  /* ---------- open / sluiten ---------- */
  function open() {
    if (!drawer) return;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    render();
  }
  function close() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  /* ---------- cart ophalen + tekenen ---------- */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function updateCount(count) {
    (countEls || []).forEach(function (e) { e.textContent = count; });
    document.querySelectorAll('[data-hg-count-badge]').forEach(function (e) { e.textContent = count; });
  }

  function render() {
    return getCart().then(function (cart) {
      updateCount(cart.item_count);
      if (!cart.items.length) {
        body.innerHTML = '<div class="hg-empty">Je winkelwagen is nog leeg.</div>';
        foot.hidden = true;
        return cart;
      }
      foot.hidden = false;
      var html = '';
      cart.items.forEach(function (it, i) {
        html += itemHTML(it, i + 1);
      });
      html += notesHTML(cart.note);
      html += '<div class="hg-cross" data-hg-cross hidden></div>';
      body.innerHTML = html;

      // footer
      foot.innerHTML = shipHTML(cart.total_price)
        + '<div class="hg-subtotal"><span>' + esc(S.subtotal || 'Subtotaal (incl. btw)') + '</span><strong>' + formatMoney(cart.total_price) + '</strong></div>'
        + '<a href="/checkout" class="hg-checkout">' + esc(S.checkout || 'Verder naar bestellen') + '</a>'
        + trustHTML();

      initTrust();
      loadCrossSell(cart);
      return cart;
    });
  }

  function itemHTML(it, line) {
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="hg-item__variant">' + esc(it.options_with_values && it.options_with_values.length ? it.options_with_values.map(function (o) { return o.name + ': ' + o.value; }).join(', ') : it.variant_title) + '</div>' : '';
    return '' +
      '<div class="hg-item" data-line="' + line + '" data-key="' + esc(it.key) + '">' +
        '<a class="hg-item__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="hg-item__main">' +
          '<div class="hg-item__top">' +
            '<div><p class="hg-item__title">' + esc(it.product_title) + '</p>' + variant + '</div>' +
            '<button class="hg-item__remove" data-hg-remove aria-label="Verwijderen"><svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg></button>' +
          '</div>' +
          '<div class="hg-item__bottom">' +
            '<div class="hg-qty">' +
              '<button data-hg-dec aria-label="Minder">&minus;</button>' +
              '<input class="hg-qty__n" data-hg-qtyinput type="text" inputmode="numeric" pattern="[0-9]*" value="' + it.quantity + '" aria-label="Aantal">' +
              '<button data-hg-inc aria-label="Meer">+</button>' +
            '</div>' +
            '<div class="hg-item__price">' + formatMoney(it.final_line_price) + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function notesHTML(note) {
    return '<div class="hg-notes' + (note ? ' is-open' : '') + '" data-hg-notes>' +
      '<button class="hg-notes__toggle" data-hg-notes-toggle>' + esc(S.notes || 'Eventuele opmerkingen:') + '</button>' +
      '<textarea class="hg-notes__field" data-hg-note placeholder="">' + esc(note || '') + '</textarea>' +
    '</div>';
  }

  function shipHTML(total) {
    if (!THRESHOLD) return '';
    if (total >= THRESHOLD) {
      return '<div class="hg-ship is-done"><div class="hg-ship__text">🎉 Je hebt <b>gratis bezorging</b>!</div><div class="hg-ship__bar"><div class="hg-ship__fill" style="width:100%"></div></div></div>';
    }
    var remaining = THRESHOLD - total;
    var pct = Math.max(3, Math.min(100, Math.round((total / THRESHOLD) * 100)));
    return '<div class="hg-ship"><div class="hg-ship__text">Nog <b>' + formatMoney(remaining) + '</b> tot <b>' + esc(CFG.freeShipLabel || 'Gratis Bezorging') + '</b></div>' +
      '<div class="hg-ship__bar"><div class="hg-ship__fill" style="width:' + pct + '%"></div></div></div>';
  }

  /* ---------- cross-sell (regelgebaseerd op winkelwagen-inhoud) ---------- */
  var HK = 'hk-lazuur-douglas-2-5-liter';
  var SCREW_ZWART = 'potdekselschroef-zwart-4x50mm-200-stuks-rvs';
  var SCREW_BLANK = 'potdekselschroeven-4x50mm-200-stuks-rvs';
  var PLANK_RE = /rabat|plank|potdeksel|zweeds/;

  function itemText(i) { return (i.product_title + ' ' + i.handle + ' ' + (i.variant_title || '') + ' ' + (i.product_type || '')).toLowerCase(); }

  function getUpsellHandles(cart) {
    var texts = cart.items.map(itemText);
    function any(re) { return texts.some(function (t) { return re.test(t); }); }
    function plankColor(color) {
      return cart.items.some(function (i) { var t = itemText(i); return PLANK_RE.test(t) && new RegExp(color).test(t); });
    }
    if (any(/bouwpakket|overkapping|kapschuur|aanbouwveranda|zadeldak|schilddak|veranda/)) return ['glazen-schuifwand-3-spoor-tot-290cm', HK];
    if (any(/vlonder/)) return ['vlonderschroeven-5x50-200-stuks-rvs', HK];
    if (any(PLANK_RE)) {
      if (plankColor('zwart')) return [SCREW_ZWART, HK];   // zwarte planken -> zwarte schroef
      return [SCREW_BLANK, HK];                            // blank of geen kleur herkend -> blanke schroef
    }
    if (any(/balk|paal|palen/)) return ['tellerkopschroeven-8x240mm-50-stuks-verzinkt', HK];
    return [SCREW_ZWART, HK];
  }
  function loadCrossSell(cart) {
    var box = qs('[data-hg-cross]', body);
    if (!box || !cart.items.length) return;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var handles = getUpsellHandles(cart);
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var recs = prods.filter(function (p) { return p && !inCart[p.id]; });
      if (!recs.length) { box.hidden = true; return; }
      var h = '<h3 class="hg-cross__title">' + esc(S.crossTitle || 'Andere kochten ook') + '</h3>';
      recs.forEach(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && typeof img === 'object') img = img.src || '';
        var was = (v.compare_at_price && v.compare_at_price > v.price) ? '<span class="was">' + formatMoney(v.compare_at_price) + '</span>' : '';
        h += '<div class="hg-cross__item">' +
          '<a class="hg-cross__img" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(imgUrl(img, 140)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="hg-cross__info"><div class="hg-cross__name">' + esc(p.title) + '</div>' +
            '<div class="hg-cross__price"><span class="now">' + formatMoney(v.price) + '</span>' + was + '</div></div>' +
          '<button class="hg-cross__add" data-hg-crossadd="' + v.id + '" aria-label="Toevoegen"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>';
      });
      box.innerHTML = h;
      box.hidden = false;
    });
  }

  /* ---------- Trustpilot-widget onder de checkout ---------- */
  function trustHTML() {
    // Voorkeur: eigen badge-afbeelding (door jou geüpload). Anders: officiële widget als terugval.
    if (CFG.trustImageUrl) {
      var link = CFG.trustImageHref ? ' href="' + CFG.trustImageHref + '" target="_blank" rel="noopener"' : '';
      var open = CFG.trustImageHref ? '<a class="hg-trust__link"' + link + '>' : '<span class="hg-trust__link">';
      var close = CFG.trustImageHref ? '</a>' : '</span>';
      return '<div class="hg-trust">' + open + '<img class="hg-trust__img" src="' + CFG.trustImageUrl + '" alt="Trustpilot beoordeling" loading="lazy">' + close + '</div>';
    }
    var tp = CFG.trustpilot; if (!tp || !tp.bu) return '';
    return '<div class="hg-trust"><div class="trustpilot-widget" data-locale="' + tp.locale + '" data-template-id="' + tp.template + '" data-businessunit-id="' + tp.bu + '" data-style-height="22px" data-style-width="100%">' +
      '<a href="' + tp.href + '" target="_blank" rel="noopener">Trustpilot</a></div></div>';
  }
  function initTrust() {
    try { var w = foot.querySelector('.trustpilot-widget'); if (w && window.Trustpilot) window.Trustpilot.loadFromElement(w, true); } catch (e) {}
  }

  /* ---------- cart-mutaties ---------- */
  function changeLine(line, qty) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return render(); }).finally(function () { setLoading(false); });
  }
  function addVariant(id, qty) {
    setLoading(true);
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function () { return render(); }).finally(function () { setLoading(false); });
  }
  function saveNote(note) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: note })
    });
  }

  /* ---------- events binnen drawer ---------- */
  function bindDrawer() {
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-hg-close]')) { close(); return; }
      var item = t.closest('.hg-item');
      if (item) {
        var line = parseInt(item.getAttribute('data-line'), 10);
        var n = parseInt(qs('.hg-qty__n', item).value, 10) || 1;
        if (t.closest('[data-hg-inc]')) { changeLine(line, n + 1); return; }
        if (t.closest('[data-hg-dec]')) { changeLine(line, Math.max(0, n - 1)); return; }
        if (t.closest('[data-hg-remove]')) { changeLine(line, 0); return; }
      }
      var toggle = t.closest('[data-hg-notes-toggle]');
      if (toggle) { toggle.closest('[data-hg-notes]').classList.toggle('is-open'); return; }
      var crossAdd = t.closest('[data-hg-crossadd]');
      if (crossAdd) { addVariant(parseInt(crossAdd.getAttribute('data-hg-crossadd'), 10), 1); return; }
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-hg-note]')) { saveNote(e.target.value); return; }
      if (e.target.matches('[data-hg-qtyinput]')) {
        var item = e.target.closest('.hg-item');
        if (!item) return;
        var line = parseInt(item.getAttribute('data-line'), 10);
        var q = parseInt(e.target.value, 10);
        if (isNaN(q) || q < 0) { render(); return; }   // ongeldige invoer -> herstel
        changeLine(line, q);
      }
    });
    // Enter in het aantal-veld bevestigt de invoer
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-hg-qtyinput]')) { e.preventDefault(); e.target.blur(); }
    });
  }

  /* ---------- triggers op de site ---------- */
  var CART_SEL = 'a[href="/cart"],a[href$="/cart"],a[href*="/cart?"],.site-header-cart--button,.site-header__cart-toggle,[data-hg-open]';
  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var trg = e.target.closest(CART_SEL);
      if (trg && !e.target.closest('.hg-cart')) { e.preventDefault(); e.stopPropagation(); open(); }
    }, true);

    // Toevoegen aan winkelwagen onderscheppen -> AJAX + drawer openen
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var fd = new FormData(form);
      setLoading(true);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { open(); })
        .catch(function () { form.submit(); })
        .finally(function () { setLoading(false); });
    }, true);
  }

  /* ---------- init ---------- */
  function init() {
    drawer = el('hg-cart'); overlay = el('hg-cart-overlay');
    if (!drawer || !overlay) return;
    body = qs('[data-hg-body]', drawer); foot = qs('[data-hg-foot]', drawer);
    countEls = Array.prototype.slice.call(document.querySelectorAll('[data-hg-count]'));
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    bindDrawer();
    bindTriggers();
    getCart().then(function (c) { updateCount(c.item_count); });
    window.HGCart = { open: open, close: close, refresh: render };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
